import { createStore } from '@mpxjs/core'
import api from '../lib/service'

export default createStore({
  state: {
    userInfo: {},
    cityInfo: { lat: '', lng: '', cityId: null },
    productType: 'didi',
    initData: {},
    query: {},
    trackInfo: { hasTrackLogin: false, hasTrackLocate: false },
    PerfTrack: null,
  },
  getters: {
    userInfo: state => state.userInfo,
    cityInfo: state => state.cityInfo,
    productType: state => state.productType,
    initData: state => state.initData,
    query: state => state.query,
    trackInfo: state => state.trackInfo,
    PerfTrack: state => state.PerfTrack,
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setCityInfo(state, cityInfo) {
      if (
        state.cityInfo.cityId &&
        cityInfo.cityId &&
        state.cityInfo.cityId !== cityInfo.cityId
      ) {
        return
      }
      state.cityInfo = Object.assign({}, state.cityInfo, cityInfo)
    },
    setProductType(state, productType) {
      state.productType = productType
    },
    setInitData(state, initData) {
      state.initData = initData
    },
    setPosterSaved(state, { has_saved_poster, save_poster_bonus }) {
      state.initData.activity_info.has_saved_poster = has_saved_poster
      save_poster_bonus &&
        (state.initData.activity_info.save_poster_bonus = save_poster_bonus)
    },
    setQuery(state, query) {
      state.query = query
    },
    setSignInfo(state, signInfo) {
      state.initData.sign_in_infos = signInfo
    },
    setTrackInfo(state, trackInfo) {
      state.trackInfo = trackInfo
    },
    reset(state) {
      state.userInfo = {}
      state.initData = {}
      state.cityInfo = { lat: '', lng: '', cityId: null }
      state.trackInfo = { hasTrackLogin: false, hasTrackLocate: false }
      state.PerfTrack = null
      // query 已经被重新赋值
    },
    setPerfTrack(state, PerfTrack) {
      state.PerfTrack = PerfTrack
    },
  },
  actions: {
    async getInitData({ commit }, params = {}) {
      const week = params.week ?? ''
      const hasLocate = params.hasLocate
      // week 0-6 代表周日到周六
      // sign_in_week 1-7 代表周一到周日
      const res = await api.init({ sign_in_week: week }, { hasLocate })
      if (res.errno === 0) {
        res.data.sign_in_week = week === '' ? undefined : week === 0 ? 7 : week
        commit('setInitData', res.data)
      }
      return res
    },
  },
})

export const pageStyle = {
  wyc: {
    businessId: 256,
  },
  dj: {
    businessId: 261,
    headerImage:
      // 'https://ut-static.udache.com/webx/ut/J06mJ9bv541R12ycBbWI8.png',
      // 'https://ut-static.udache.com/webx/ut/tsU7dKecxB1qMVb_uVgK7.png',
      'https://ut-static.udache.com/webx/ut/j0sSDC2PPqRJ0FblWFoTd.jpeg',
    couponDefaultName: '',
    // couponBg: 'https://ut-static.udache.com/webx/ut/0Uyyng0doVcKgCCqNxl08.png',
    couponBg: 'https://ut-static.udache.com/webx/ut/u09uv7tmKXeT8oRnTbj7g.png',
    couponListBg:
      // 'https://ut-static.udache.com/webx/ut/t7M5TrfvVlJfvnElDtB_y.png',
      'https://ut-static.udache.com/webx/ut/6J4memz8mIeMRMepZA_tk.png',
    couponListFooterImage:
      // 'https://ut-static.udache.com/webx/ut/2Vbmf1tJZDOPhH0nnDtVk.png',
      'https://ut-static.udache.com/webx/ut/ffhtaI5WPaBqZQDaTvf8P.png',
    couponListBtnFooterBg:
      'linear-gradient(180deg, rgba(72,160,163,0.00) 0%, #48A0A3 49%)',
    // couponListBtnBoxShadow: '0px 1.6vw 2.7vw 0px rgba(11,140,144,1)',
    couponListBtnBoxShadow: '0px 0px 0px 0px rgba(11,140,144,1)',
    btnBgImg: 'https://ut-static.udache.com/webx/ut/PzvYs8p0juK4HaJZzCZI0.png',
  },
  hy: {
    businessId: 596,
    headerImage:
      'https://ut-static.udache.com/webx/ut/8JBAsQnIRdj5T53Oci1rc.png',
    couponDefaultName: '货运福利券包',
    couponBg: 'https://ut-static.udache.com/webx/ut/GnCcI7nld1lX0sgEN5xGu.png',
    couponListBg:
      'https://ut-static.udache.com/webx/ut/dZ_495CLbb8LVyQbYmn6G.png',
    couponListFooterImage:
      'https://ut-static.udache.com/webx/ut/ZKbb4LkByxtXBrLZMCX4u.png',
    couponListBtnFooterBg:
      'linear-gradient(180deg, rgba(79,175,134,0.00) 0%, #4FAF86 49%)',
    couponListBtnBoxShadow: '0px 1.6vw 2.7vw 0px rgba(60,154,114,1)',
  },
  hxz: {
    businessId: 430,
    headerImage:
      'https://ut-static.udache.com/webx/ut/RcxJMOQ32X3uNoaq1NdnF.png',
    couponDefaultName: '花小猪福利券包',
    couponBg: 'https://ut-static.udache.com/webx/ut/4rZLhYMrYBbZY9O2jW5Ft.png',
    couponListBg:
      'https://ut-static.udache.com/webx/ut/dDnKnWDBS9FeTo5_d04W1.png',
    couponListFooterImage:
      'https://ut-static.udache.com/webx/ut/3WdvbV9Iwvv_QPdB_JaWl.png',
    couponListBtnFooterBg:
      'linear-gradient(180deg, rgba(81,11,185,0.00) 0%, #510BB9 49%)',
    couponListBtnBoxShadow: '0px 1.6vw 2.7vw 0px rgba(54,0,134,1)',
  },
  ny: {
    businessId: 321,
    headerImage:
      'https://ut-static.udache.com/webx/ut/mwvoJrZzzGKYosoziQNtW.png',
    couponDefaultName: '加油福利券包',
    couponBg: 'https://ut-static.udache.com/webx/ut/s4e3Ho3Ld9OrjO5zIdgc9.png',
    couponListBg:
      'https://ut-static.udache.com/webx/ut/0nrI-r329FIWy6vXGLPCt.png',
    couponListFooterImage:
      'https://ut-static.udache.com/webx/ut/WQX8TYWhj36hyCUCQVrI-.png',
    couponListBtnFooterBg:
      'linear-gradient(180deg, rgba(179,45,31,0.00) 0%, #B32D1F 50%)',
    couponListBtnBoxShadow: '0px 1.6vw 2.7vw 0px rgba(131,5,5,0.57)',
  },
  cz: {
    businessId: 90002,
    indexStyle: {
      backgroundImage:
        'https://ut-static.udache.com/webx/ut/tjkNdWS4tHLevW1M1lbKa.png',
      backgroundColor: '#FFCB8D',
    },
    couponDefaultName: '滴滴有车专享券包',
    couponSubTitle: '内含加油、代驾、充电、车品等券',
    couponBg: 'https://ut-static.udache.com/webx/ut/tQhjiQMSE4dlrzpBIRlLX.png',
    couponListBg:
      'https://ut-static.udache.com/webx/ut/tQhjiQMSE4dlrzpBIRlLX.png',
    couponListFooterImage:
      'https://ut-static.udache.com/webx/ut/xBpp-8vIQpdk3bYHnIawr.png',
    couponListBtnFooterBg:
      'linear-gradient(180deg, rgba(179,45,31,0.00) 0%, #B32D1F 50%)',
    couponListBtnBoxShadow: '0px 10px 19px 0px rgba(155,53,0,0.48)',
  },
  zc: {
    // businessId: 40068,
    couponBg: 'https://ut-static.udache.com/webx/ut/hDqZ6xRT8DGmgvUHzWYTL.png',
  },
}
